/*
 * @providesModule SkillzButtonCoordinator
 *
 */

import React from 'react';

import ClientPropertyConstants from 'ClientPropertyConstants';

// SkillzButton from Silver (from this repo) is deemed V1
import SkillzButtonV1, {ButtonProps as SkillzButtonV1Props} from 'SkillzButton';
// SkillzButton from Tungsten (from skillz-ui repo) is deemed V2
import {
  SkillzButton as SkillzButtonV2,
  ISkillzButtonProps as SkillzButtonV2Props,
} from '@skillz-rn/atoms';
import {View} from 'react-native';

export interface ISkillzButtonCoordinatorProps {
  /** If we're looking at Silver, provide button props in v1ButtonProps */
  v1ButtonProps?: SkillzButtonV1Props;
  /** If we're looking at Tungsten, provide button props v2ButtonProps */
  v2ButtonProps?: SkillzButtonV2Props;
}

/**
 * Function to get necessary props to pass into SkillzButtonCoordinator. Text, onPress,
 * and testID are always required. Any additional props are passed in by version
 * number of the skillz button.
 */
export const getButtonCoordinatorProps = (
  text: string,
  onPress: any,
  testID: string,
  v1ExtraProps: SkillzButtonV1Props,
  v2ExtraProps: SkillzButtonV2Props
): ISkillzButtonCoordinatorProps => {
  const v1ButtonProps = {
    ...v1ExtraProps,
    title: text,
    onPress,
    testID,
  };
  const v2ButtonProps = {
    ...v2ExtraProps,
    text,
    onPress,
    testID,
  };
  return {
    v1ButtonProps,
    v2ButtonProps,
  };
};

/**
 * This Coordinator is used for Tungsten AB testing. Will dispatch to the correct
 * skillz button depending on if user is on Silver or Tungsten, which is determined
 * by client prop
 */
const SkillzButtonCoordinator = ({
  v1ButtonProps,
  v2ButtonProps,
}: ISkillzButtonCoordinatorProps): React.ReactElement => {
  // Show V2 button if user has Tungsten Core Loop
  if (ClientPropertyConstants.isCoreLoopTungstenEnabled() && v2ButtonProps) {
    return <SkillzButtonV2 {...v2ButtonProps} />;
  }
  // Show V1 button if user has Silver Core Loop
  if (!ClientPropertyConstants.isCoreLoopTungstenEnabled() && v1ButtonProps) {
    return <SkillzButtonV1 {...v1ButtonProps} />;
  }
  // Should match one of those two; error handle to render empty view
  return <View />;
};

export default SkillzButtonCoordinator;
